import { render } from "./TerminalSetup.vue?vue&type=template&id=f9e75c2e&scoped=true"
import script from "./TerminalSetup.vue?vue&type=script&lang=js"
export * from "./TerminalSetup.vue?vue&type=script&lang=js"

import "./TerminalSetup.vue?vue&type=style&index=0&id=f9e75c2e&lang=less&scoped=true"

import exportComponent from "C:\\REPOS\\pos-web-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f9e75c2e"]])

export default __exports__